import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { store } from './redux/store';
import { AnimationWrapper } from './views/animate';
import { PhotoMode } from './views/PhotoMode';

const LayoutComponent = () => (
	<Provider store={store}>
		<AnimationWrapper>
			<Background />
			<PhotoMode />
		</AnimationWrapper>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.PhotoMode)
	.setTransitionTime(300)
	.build();

export default Layout;
